import "./sidebar.css";

import classNames from "classnames";
import { ReactNode } from "react";

const Sidebar = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div className={classNames("Sidebar", className)} role="dialog">
      <div className="Sidebar__container">{children}</div>
    </div>
  );
};

export default Sidebar;
